import '@airship-platform/airship-auth';
import {
  createBrowserRouterWithSentry,
  EnvironmentProvider,
} from '@airship-platform/airship-patterns';
import { registrationTheme } from '@airship-platform/jam-web/theme/registration';
import { version } from 'package.json';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider, ScrollRestoration } from 'react-router';
import App from './App';
import routes from './routes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
const signInUrl = import.meta.env.VITE_SIGN_IN_URL;
const mode = import.meta.env.VITE_MODE;
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const basePublicFilesUrl = import.meta.env.VITE_PUBLIC_FILES_BUCKET;
const amplitudeApiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
const isAmplitudeEnabled =
  !import.meta.env.VITE_ENABLE_AMPLITUDE ||
  import.meta.env.VITE_ENABLE_AMPLITUDE === 'true';
const gtmContainerId = import.meta.env.VITE_GTM_CONTAINER_ID;
const isGTMEnabled = import.meta.env.VITE_GTM_ENABLED === 'true';

const rootComponent = document.getElementById('root') as HTMLElement;
rootComponent.setAttribute('data-app-version', version);
const root = ReactDOM.createRoot(rootComponent);

const buildRoutes = createBrowserRouterWithSentry(
  [
    {
      element: (
        <EnvironmentProvider
          env={mode}
          apiBaseUrl={apiBaseUrl}
          theme={registrationTheme}
          authConfig={{
            signInUrl,
            apiBaseUrl,
            basePublicFilesUrl,
            callbackUrl: '/signup/callback',
          }}
          assetsConfig={{ basePublicFilesUrl }}
          sentryConfig={{ sentryDsn, mode, version }}
          amplitudeConfig={{
            apiKey: amplitudeApiKey,
            enableAmplitude: isAmplitudeEnabled,
            version,
          }}
          gtmConfig={{
            containerIds: [gtmContainerId],
            enableGTM: isGTMEnabled,
          }}
        >
          <App />
          <ScrollRestoration getKey={(location) => location.pathname} />
        </EnvironmentProvider>
      ),
      children: routes,
    },
  ],
  { basename: '/signup' }
);

root.render(
  <StrictMode>
    <RouterProvider router={buildRoutes()} />
  </StrictMode>
);
